import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { mapPluginSubmitData } from '../vp-ui/pages/PluginPage/helpers';
import { deepEquals } from '../utils';
import { useFetchPluginById } from './index';

const pluginContentSort = (a, b) => {
  if (a.id < b.id) {
    return -1;
  }
  if (a.id > b.id) {
    return 1;
  }
  return 0;
};

export const hasFormChanged = (formData, fetchData, enabledFontSize) => {
  const { data } = mapPluginSubmitData({ values: formData, fetchData, enabledFontSize });
  const obj1 = {
    name: data.name,
    showVideoPeelLogo: data.showVideoPeelLogo,
    sortOrder: data.sortOrder,
    ...data.styles
  };
  const obj2 = {
    name: fetchData.name,
    showVideoPeelLogo: fetchData.showVideoPeelLogo,
    sortOrder: fetchData.sortOrder,
    ...fetchData.styles
  };
  return !deepEquals(obj1, obj2);
};

export const getHasPublishChanges = (fetchData, publishedData) => {
  const fetchObj = fetchData || {};
  const publishedObj = publishedData || {};

  const fetchContent = fetchObj?.content?.map((item) => {
    delete item?.transcription;
    return item;
  });

  delete fetchObj?.role;

  const fetchCompareObj = {
    ...fetchObj,
    content: fetchContent?.sort(pluginContentSort)
  };
  const publishCompareObj = {
    ...publishedObj,
    content: publishedObj?.content?.sort(pluginContentSort)
  };

  return !deepEquals(fetchCompareObj, publishCompareObj);
};

export const usePluginHelpers = (enabledFontSize) => {
  const { data: fetchData } = useFetchPluginById();
  const { data: publishedData } = useFetchPluginById({ preview: false });
  const { watch } = useFormContext();
  const values = watch();

  const isDirty = useMemo(() => {
    if (!fetchData) {
      return false;
    }

    return hasFormChanged(values, fetchData, enabledFontSize);
  }, [values]);

  const hasPublishChanges = useMemo(
    () => getHasPublishChanges(fetchData, publishedData),
    [fetchData, publishedData]
  );

  return {
    isDirty,
    hasPublishChanges
  };
};



// WEBPACK FOOTER //
// ./src/hooks/usePluginHelpers.js